import Vue from "vue";
import Vuex from 'vuex'
import config from './config.json'
Vue.use(Vuex)
const store = new Vuex.Store({
    state: {
      routes:[],
      userlogeado:{},
      nameCookie:config.nameCookie
    },
    mutations: {
        routesUser (routes) {
        routes=routes
      },
    }
  })

  export default store